import { useEffect, useState } from "react";
import { fetchScoringPlans, createScoringPlan, deleteScoringPlan } from "./api";

const ScoringPlans = () => {
  const [scoringPlans, setScoringPlans] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newPlan, setNewPlan] = useState({
    name: '',
    description: '',
    elements: []
  });

  useEffect(() => {
    loadScoringPlans();
  }, []);

  const loadScoringPlans = async () => {
    const data = await fetchScoringPlans();
    setScoringPlans(data || []);
  };

  const handleCreatePlan = async (e) => {
    e.preventDefault();
    await createScoringPlan(newPlan);
    setShowCreateForm(false);
    setNewPlan({ name: '', description: '', elements: [] });
    loadScoringPlans();
  };

  return (
    <div className="scoring-container">
      <div className="scoring-header">
        <h1>Scoring Plans</h1>
        <button 
          className="create-btn"
          onClick={() => setShowCreateForm(true)}
        >
          Create New Plan
        </button>
      </div>

      {showCreateForm && (
        <div className="create-form">
          <form onSubmit={handleCreatePlan}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                value={newPlan.name}
                onChange={(e) => setNewPlan({...newPlan, name: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={newPlan.description}
                onChange={(e) => setNewPlan({...newPlan, description: e.target.value})}
              />
            </div>
            <div className="form-actions">
              <button type="submit">Create Plan</button>
              <button type="button" onClick={() => setShowCreateForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="scoring-table-container">
        <table className="scoring-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Elements</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {scoringPlans.map(plan => (
              <tr key={plan.itemId}>
                <td>{plan.metadata.name}</td>
                <td>{plan.metadata.description}</td>
                <td>{plan.elements?.length || 0} elements</td>
                <td>
                  <button className="edit-btn">Edit</button>
                  <button 
                    className="delete-btn"
                    onClick={() => deleteScoringPlan(plan.itemId)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScoringPlans; 